import React, { useState, useEffect } from 'react'
import googleMapsPlacesService from '../../services/googleMapsPlacesService'

const SecContact = () => {
    const [openingHours, setOpeningHours] = useState({
        formatted: '',
        isOpen: null,
        loading: true
    });

    useEffect(() => {
        const fetchOpeningHours = async () => {
            try {
                const placeId = 'ChIJI4b8Z6a5uEcRByDct58TyzM';
                
                if (!placeId) {
                    console.warn('Google Place ID not configured, using fallback hours');
                    setOpeningHours({
                        formatted: 'Mo-Fr: 9:00 - 18:00\nSa: 10:00 - 16:00\nSo: Geschlossen',
                        isOpen: null,
                        loading: false
                    });
                    return;
                }

                const hoursData = await googleMapsPlacesService.getOpeningHours(placeId);
                console.log('Fetched Opening Hours Data:', hoursData);
                if (hoursData.error) {
                    console.warn('Failed to fetch opening hours:', hoursData.error);
                    setOpeningHours({
                        formatted: 'Mo-Fr: 9:00 - 18:00\nSa: 10:00 - 16:00\nSo: 10:00 - 12:00',
                        isOpen: null,
                        loading: false
                    });
                    return;
                }

                const formattedHours = googleMapsPlacesService.formatOpeningHours(hoursData.weekdayText);
                
                setOpeningHours({
                    formatted: formattedHours.formatted,
                    isOpen: hoursData.isOpen,
                    loading: false,
                    rawData: hoursData,
                    placeName: hoursData.placeName
                });
            } catch (error) {
                console.error('Error fetching opening hours:', error);
                setOpeningHours({
                    formatted: 'Mo-Fr: 9:00 - 18:00\nSa: 10:00 - 16:00\nSo: Geschlossen',
                    isOpen: null,
                    loading: false
                });
            }
        };

        fetchOpeningHours();
    }, []);
    return (
        <section id="contact">
            <div className="container">
                <div className="wrapper__contact-wrap position-relative">
                    <img src="./../images/Group 39878.png" className="images__ornamen-contact d-none d-lg-block" alt="" />
                    <div className="row position-relative z-2">
                        <div className="col-lg-7 offset-lg-5">
                            <div className="contact-info">
                                {/* <img src="./../images/logo.svg" className="mb-3" alt="Logo" style={{maxHeight: '60px'}} /> */}
                                
                                <h2 className="normal font__size--40 text__40-1024 text__40-md text__40-mm mb-4">Komm und schau vorbei</h2>
                                <p>
Besuche unser Gartencenter und wähle persönlich die schönsten Pflanzen für dein Zuhause und deinen Garten aus.
Unser erfahrenes Team berät dich gern und hilft dir bei der Auswahl der passenden Lösungen.
                                </p>
                                
                                <div className="store-details mb-4">
                                    <div className="contact-item mb-2 d-flex align-items-start">
                                        <div className="d-flex align-items-center justify-content-center me-4 mt-1" style={{width: '35px', height: '35px', backgroundColor: '#809D79', borderRadius: '50%'}}>
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                                                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                                            </svg>
                                        </div>
                                        <p className="normal font__size--14 text__14-1024 color__gray-1 mb-0 ml-3" style={{marginTop: '8px'}}>weroflowers@gmx.de</p>
                                    </div>
                                    
                                    <div className="contact-item mb-2 d-flex align-items-start">
                                        <div className="d-flex align-items-center justify-content-center me-4 mt-1" style={{width: '35px', height: '35px', backgroundColor: '#809D79', borderRadius: '50%', flexShrink: 0}}>
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                                                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                                            </svg>
                                        </div>
                                        <div>
                                            <p className="normal font__size--14 text__14-1024 color__gray-1 mb-2 ml-3" style={{marginTop: '8px'}}>Düsseldorfer Landstraße 189, 47249 Duisburg, Deutschland</p>
                                            <a href="https://www.google.com/maps/search/?api=1&query=Düsseldorfer+Landstraße+189,+47249+Duisburg,+Deutschland" target="_blank" rel="noopener noreferrer" className="medium font__size--12 text__12-1024 btn btn__orange color__white shadow rounded__50 pointer d-inline-block ms-3 ml-3" style={{padding: '6px 12px', fontSize: '12px', textDecoration: 'none'}}>Navigate to</a>
                                        </div>
                                    </div>
                                    
                                    <div className="contact-item mb-2 d-flex align-items-start">
                                        <div className="d-flex align-items-center justify-content-center me-4 mt-1" style={{width: '35px', height: '35px', backgroundColor: '#809D79', borderRadius: '50%'}}>
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                                                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                                            </svg>
                                        </div>
                                        <p className="normal font__size--14 text__14-1024 color__gray-1 mb-0 ml-3" style={{marginTop: '8px'}}>015208599686</p>
                                    </div>
                                    
                                    <div className="contact-item mb-3 d-flex align-items-start">
                                        <div className="d-flex align-items-center justify-content-center me-4 mt-1" style={{width: '35px', height: '35px', backgroundColor: '#809D79', borderRadius: '50%'}}>
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                                                <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
                                                <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                                            </svg>
                                        </div>
                                        <div className="ml-3" style={{marginTop: '8px'}}>
                                            {openingHours.loading ? (
                                                <p className="normal font__size--14 text__14-1024 color__gray-1 mb-0">Öffnungszeiten laden...</p>
                                            ) : (
                                                <>
                                                    <p className="normal font__size--14 text__14-1024 color__gray-1 mb-0" 
                                                       style={{whiteSpace: 'pre-line'}}>
                                                        {openingHours.formatted}
                                                    </p>
                                                    {openingHours.isOpen !== null && (
                                                        <span 
                                                            className={`badge mt-2 ${openingHours.isOpen ? 'badge-success' : 'badge-secondary'}`}
                                                            style={{
                                                                backgroundColor: openingHours.isOpen ? '#28a745' : '#6c757d',
                                                                color: 'white',
                                                                fontSize: '11px',
                                                                padding: '4px 8px',
                                                                borderRadius: '12px'
                                                            }}
                                                        >
                                                            {openingHours.isOpen ? 'Jetzt geöffnet' : 'Geschlossen'}
                                                        </span>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SecContact